export default "__VITE_ASSET__1711e863__"